import { DateTime, DateTimeOffset, FilterOperators, RuntimeVariables } from '@nts/std/types';
import { Expose, Transform, Type } from '@nts/std/serialization';
import type { FilterInterface } from '@nts/std/interfaces';

export class Filter implements FilterInterface {

    /**
     * Nome della property. Deve essere comprensivo del path nel caso in cui sia di una entità all'interno di un aggregato
     */
    @Expose()
    name: string;

    /**
     * Valore con cui eseguire la ricerca
     */
    @Expose()
    value: any;

    /**
     * Lista di valori con cui eseguire la ricerca
     */
    @Expose()
    values: any[];

    /**
     * Lista di valori con cui eseguire la ricerca nel caso di DateTimeOffset
     */
    @Expose()
    @Type(() => DateTimeOffset)
    @Transform(DateTimeOffset.transform)
    dateTimeOffSetValues?: DateTimeOffset[];

    /**
     * Lista di valori con cui eseguire la ricerca nel caso di DateTime
     */
    @Expose()
    @Transform(DateTime.transform)
    dateTimeValues?: Date[];

    /**
     * Valore con cui eseguire la ricerca nel caso di DateTimeOffset
     */
    @Expose()
    @Transform(DateTimeOffset.transform)
    dateTimeOffSetValue?: DateTimeOffset;

    /**
     * Valore con cui eseguire la ricerca nel caso di DateTime
     */
    @Expose()
    @Transform(DateTime.transform)
    dateTimeValue?: Date;

    /**
     * Nel caso di opeatore between rappresenta il valore maggiore con cui effettuare la ricerca
     */
    @Expose()
    upperValue: any;

    /**
     * Nel caso di opeatore between rappresenta il valore maggiore con cui effettuare la ricerca
     */
    @Expose()
    @Transform(DateTimeOffset.transform)
    dateTimeOffSetUpperValue?: DateTimeOffset;

    /**
     * Nel caso id opeatore between rappresenta il valore maggiore con cui effettuare la ricerca
     */
    @Expose()
    @Transform(DateTime.transform)
    dateTimeUpperValue?: Date;

    /**
     * Indica se come valore utilizzare una varibile di ambiente
     */
    @Expose()
    runtimeVariable?: RuntimeVariables;

    /**
     * Nel caso id opeatore between rappresenta il valore maggiore con cui effettuare la ricerca
     */
    @Expose()
    runtimeVariableUperrValue?: RuntimeVariables;

    /**
     * Operatore con cui effettuare la ricerca
     */
    @Expose()
    operator: FilterOperators;

    /**
     * Se true forza l'applicazione del filtro in AND
     */
    @Expose()
    applyAndLogic: boolean;


    // I filtri locked non vengono salvati, ma servono solo per nascondere determinati filtri preimpostati
    @Expose()
    isLocked: boolean;
}
